import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

// material ui
import Typography from '@mui/material/Typography'

const formatTime = ({ startsAt, endsAt }) => {
  const start = moment(startsAt).format('h:mmA')
  const end = moment(endsAt).format('h:mmA')
  return `${start}–${end}`
}

const RoomMeetingSchedule = props => {
  const {
    roomMeeting, // via withQuery
    liveNow, // via RoomCardContainer/withState
    variant
  } = props

  const { id, startsAt, endsAt } = roomMeeting

  return (
    <Typography key={id} variant={variant || 'caption'} component='p'>
      {formatTime({ startsAt, endsAt })}
      {liveNow && (
        <Typography
          color='error.main'
          fontWeight='fontWeightBold'
          fontSize='20px'
          variant={variant || 'caption'}
          component='span'
        >
          {' '}
          Live Now!
        </Typography>
      )}
    </Typography>
  )
}

RoomMeetingSchedule.propTypes = {
  roomMeeting: PropTypes.object.isRequired
}

export default RoomMeetingSchedule
